/*项目申报 表格数据填写*/
import {apiRequest} from "@/api/api";

//--------------------------------------申报表格数据

/*根据项目类型获取表格项目*/
export function getApplyTableItem(config) {
   config.method = 'get'
   config.url = '/project/PaAdvEnpItem/getTableItem'
   apiRequest(config);
}

/*根据申请编号获取表格数据*/
export function getApplyTableData(config) {
   config.method = 'get'
   config.url = '/project/PaAdvEnpTable/getTableData'
   apiRequest(config);
}

/*提交申报表格数据*/
export function postApplyTableData(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaAdvEnpTable/submitTableData'
   apiRequest(config)
}